<script>
	import SuperInput from '$lib/Components/Forms/SuperInput/SuperInput.svelte';

	import Images from '$lib/Components/Forms/Images/Images.svelte';
	import SuperForm from '$lib/Components/Forms/SuperForm/SuperForm.svelte';
	import leadSchema from '$lib/PageSections/Forms/schemas/lead.schema.js';
	let {
		data = null,
		buttonText = 'Submit',
		action = '/forms/claim-submission',
		class: className = null,
		text,
	} = $props();
</script>

<div class={['mb-4 w-full rounded-lg bg-indow-white p-6 shadow-lg', className]}>
	<p class="text-left text-sm">
		{#if text}{@render text()}{:else}
			<span>
				We’re very sorry to hear that you’ve experienced issues with your Indow
				inserts, but we look forward to working with you to rectify them. Please
				fill out the form below to submit a claim.
			</span>
		{/if}
	</p>
	<SuperForm
		{data}
		formName="claim-submission"
		enctype="multipart/form-data"
		method="POST"
		schema={leadSchema}
		{buttonText}
		{action}
	>
		{#snippet children({ form, disabled })}
			<SuperInput
				{form}
				{disabled}
				name="firstName"
				label="First Name"
				autocomplete="given-name"
				class="xs:col-span-1"
			/>
			<SuperInput
				{form}
				{disabled}
				name="lastName"
				label="Last Name"
				autocomplete="family-name"
				required
				class="xs:col-span-1"
			/>
			<SuperInput
				{form}
				{disabled}
				type="email"
				name="email"
				label="Email"
				autocomplete="email"
				required
				class="col-span-full"
			/>
			<SuperInput
				{form}
				{disabled}
				type="tel"
				name="phone"
				label="Phone"
				autocomplete="phone"
				class="col-span-full"
			/>
			<SuperInput
				{form}
				{disabled}
				name="supportOrderNumber"
				type="text"
				label="Order Number"
				autocomplete="off"
				class="col-span-full"
			/>
			<SuperInput
				{form}
				{disabled}
				name="supportNotes"
				type="textarea"
				label="How can we help you?"
				autocomplete="off"
				class="col-span-full"
			/>
			<Images {form} inputName="images" class="col-span-full" />
		{/snippet}
	</SuperForm>
	<p class="text-left text-sm">
		Alternatively, you can schedule a call with a Claims Specialist: <a
			href="https://claims-specialist.youcanbook.me"
			rel="external"
		>
			here</a
		>.
	</p>
	<p class="text-left text-sm">
		Thank you for reporting this, and please keep an eye open for further
		notifications specific to your reported issue within 1-2 business days.
	</p>
</div>
